import { UserModel } from "./UserModel";
import { PriorityModel } from "./PriorityModel";
import { StatusModel } from "./StatusModel";
import { QueueRelationModel } from "./QueueRelationModel";

/**
 * * Модель подзадачи
 */
export class SubtaskModel {
  /**ID задачи */
  Id!: number;
  /**Название задачи */
  Name!: string;
  /**Статус задачи */
  Status!: StatusModel;
  /**Приоритет задачи */
  Priority!: PriorityModel;
  /**Название очереди */
  QueueName!: string;
  /**Очереди задачи */
  Queues: QueueRelationModel[] = [];
  /**Исполнители */
  Performers: Array<UserModel> = [];

  constructor(obj?: Partial<SubtaskModel>) {
    Object.assign(this, obj);
  }
}
